import { render, staticRenderFns } from "./SiteSearch.vue?vue&type=template&id=ea968a6c&scoped=true&"
import script from "./SiteSearch.vue?vue&type=script&lang=js&"
export * from "./SiteSearch.vue?vue&type=script&lang=js&"
import style0 from "./SiteSearch.vue?vue&type=style&index=0&id=ea968a6c&lang=scss&scoped=true&"
import style1 from "./SiteSearch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea968a6c",
  null
  
)

/* custom blocks */
import block0 from "./SiteSearch.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports